export class PermissionDc{   
    public ScreenId:number;
    public ScreenName:string;
    public Add:boolean
    public Update:boolean;
    public Delete:boolean;
    public View:boolean; 
}
export class RolePermissionDc{       
    public RoleId:number;    
    public RoleName:string; 
    public UserType:string;
    public PermissionDcs: Array<PermissionDc>;
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/security/permission.dc.ts